<template>
  <v-container
    fluid
  >
    <v-row>
      <v-col
        cols="12"
        md="12"
        sm="12"
        lg="6"
      >
        <base-material-card
          class="px-4 py-3"
          color="bgTank"
          icon="mdi-octagon"
        >
          <template v-slot:after-heading>
            <div class="display-1 font-weight-light text-start v-card--material__heading mb-n6 v-sheet theme--dark elevation-6 bgTank pa-8">
              {{ $t("tanks-set.information") }}
              <span class="subtitle-1">— {{ tankInfo.idNavigation.description }}</span>
            </div>
          </template>
          <validation-observer
            v-slot="{ handleSubmit }"
          >
            <form @submit.prevent="handleSubmit(updateMinimums)">
              <v-row>
                <v-col
                  cols="12"
                  md="6"
                >
                  <v-row
                    align="center"
                  >
                    <v-col
                      cols="12"
                      md="5"
                    >
                      <h3 class="info--text">
                        {{ $t('tanks-set.length') }}:
                      </h3>
                    </v-col>
                    <v-col
                      cols="12"
                      md="7"
                    >
                      <h3 class="font-weight-bold">
                        {{ tankInfo.length }}
                      </h3>
                    </v-col>
                    <v-col
                      cols="12"
                      md="5"
                    >
                      <h3 class="info--text">
                        {{ $t('tanks-set.wide') }}:
                      </h3>
                    </v-col>
                    <v-col
                      cols="12"
                      md="7"
                    >
                      <h3 class="font-weight-bold">
                        {{ tankInfo.wide }}
                      </h3>
                    </v-col>
                    <v-col
                      cols="12"
                      md="5"
                    >
                      <h3 class="info--text">
                        {{ $t('tanks-set.height') }}:
                      </h3>
                    </v-col>
                    <v-col
                      cols="12"
                      md="7"
                    >
                      <h3 class="font-weight-bold">
                        {{ tankInfo.height }}
                      </h3>
                    </v-col>
                    <v-col
                      cols="12"
                      md="5"
                    >
                      <h3 class="info--text">
                        {{ $t('tanks-set.diameter') }}:
                      </h3>
                    </v-col>
                    <v-col
                      cols="12"
                      md="7"
                    >
                      <h3 class="font-weight-bold">
                        {{ tankInfo.diameter }}
                      </h3>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col
                  cols="12"
                  md="6"
                >
                  <v-row
                    align="center"
                  >
                    <v-col
                      cols="12"
                      md="8"
                    >
                      <h3 class="info--text">
                        {{ $t('tanks-set.literCapacity') }}:
                      </h3>
                    </v-col>
                    <v-col
                      cols="12"
                      md="4"
                    >
                      <h3 class="font-weight-bold">
                        {{ tankInfo.literCapacity }}
                      </h3>
                    </v-col>
                    <v-col
                      cols="12"
                      md="8"
                    >
                      <h3 class="info--text">
                        {{ $t('tanks-set.gallonCapacity') }}:
                      </h3>
                    </v-col>
                    <v-col
                      cols="12"
                      md="4"
                    >
                      <h3 class="font-weight-bold">
                        {{ tankInfo.gallonCapacity }}
                      </h3>
                    </v-col>
                    <v-col
                      cols="12"
                      md="8"
                    >
                      <h3 class="info--text">
                        {{ $t('tanks-set.minimumLiters') }}:
                      </h3>
                    </v-col>
                    <v-col
                      cols="12"
                      md="4"
                    >
                      <validation-provider
                        v-slot="{ errors }"
                        rules="required|numeric"
                        name="tank.minimumLiters"
                      >
                        <v-text-field
                          v-model.number="tankInfo.minimumLiters"
                          :error-messages="errors"
                          color="secondary"
                          label=""
                          @keyup="calculateGallons"
                        />
                      </validation-provider>
                    </v-col>
                    <v-col
                      cols="12"
                      md="8"
                    >
                      <h3 class="info--text">
                        {{ $t('tanks-set.minimumGallons') }}:
                      </h3>
                    </v-col>
                    <v-col
                      cols="12"
                      md="4"
                    >
                      <validation-provider
                        v-slot="{ errors }"
                        rules="required|numeric"
                        name="tank.minimumGallons"
                      >
                        <v-text-field
                          v-model.number="tankInfo.minimumGallons"
                          :error-messages="errors"
                          color="secondary"
                          label=""
                          @keyup="calculateLiters"
                        />
                      </validation-provider>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
              <div class="pa-3 text-center">
                <v-btn
                  color="warning"
                  default
                  @click="goToList"
                >
                  {{ $t('goToList') }}
                </v-btn>
                <v-btn
                  color="success"
                  default
                  type="submit"
                  :loading="loadingUpdateMinimums"
                >
                  {{ $t("save") }}
                </v-btn>
              </div>
            </form>
          </validation-observer>
        </base-material-card>
      </v-col>
      <v-col
        cols="12"
        md="12"
        sm="12"
        lg="6"
      >
        <tank-state-view
          :target-device-id="targetDeviceId"
        />
      </v-col>
    </v-row>

    <alert-list
      :target-device-id="targetDeviceId"
      alert-type="Tank"
    />
    <base-material-snackbar
      v-model="showSuccessAlert"
      :dismissible="false"
      type="success"
      v-bind="{
        ['top']: true,
        ['center']: true,
        ['timeout']: 1000
      }"
    >
      <span class="text-uppercase">{{ $t('Success') }} </span>
    </base-material-snackbar>
    <base-material-snackbar
      v-model="showErrorMessage"
      type="error"
      v-bind="{
        ['top']: true,
        ['center']: true,
        ['vertical']: true
      }"
    >
      {{ errorMessage }}
    </base-material-snackbar>
  </v-container>
</template>

<script>
  import filters from '@/common/filters'
  import TankStateView from '@/views/dashboard/components/tanks/TankStateView'
  import { repositoryFactory } from '@/api/repositoryFactory'
  import AlertList from '../components/alerts/AlertList'
  const tanksRespository = repositoryFactory.get('tanks')

  export default {
    components: { TankStateView, AlertList },
    mixins: [filters],
    data () {
      return {
        tankInfo: {
          idNavigation: { },
        },
        showErrorMessage: false,
        errorMessage: '',
        showSuccessAlert: false,
        loadingUpdateMinimums: false,
      }
    },
    computed: {
      targetDeviceId () {
        return this.$route.params.id
      },
    },
    mounted () {
      var self = this
      self.fetchData(self.targetDeviceId)
    },
    methods: {
      fetchData (targetDeviceId) {
        var self = this
        tanksRespository.get(targetDeviceId).then(response => {
          self.tankInfo = Object.assign({}, response.data.data)
        }).catch(err => {
          self.showErrorMessage = true
          self.errorMessage = err
        })
      },
      updateMinimums () {
        var self = this
        var data = {
          data: this.tankInfo,
        }
        self.loadingUpdateMinimums = true
        tanksRespository.updateMinimums(data, this.tankInfo.id).then(response => {
          if (response.data.isValid) {
            self.showSuccessAlert = true
          } else {
            self.showErrorMessage = true
            self.errorMessage = response.data.errorMessages[0]
          }
          self.loadingUpdateMinimums = false
        }).catch(err => {
          self.errorMessage = err
          self.showErrorMessage = true
          self.loadingUpdateMinimums = false
        })
      },
      goToList () {
        this.$router.push({ name: 'tanks' })
      },
      calculateGallons () {
        this.tankInfo.minimumGallons = parseFloat(Math.round(this.tankInfo.minimumLiters / 3.785))
      },
      calculateLiters () {
        this.tankInfo.minimumLiters = parseFloat(Math.round(this.tankInfo.minimumGallons * 3.785))
      },
    },
  }
</script>

<style lang="sass">

</style>
